'use strict';

angular.module('AcaApp').controller('EulaController', [
  '$scope',
  'LayoutService',
  '$location',
  '$window',
  '$templateCache',
  'SecurityService',
  'AuthenticationService',
  function($scope, LayoutService, $location, $window, $templateCache, SecurityService, AuthenticationService){
    LayoutService.setBody('gray-bg-no-admin');
    $scope.eulaAccepted = $window.sessionStorage.eulaAccepted;
    if ($scope.eulaAccepted) {
      if($window.sessionStorage.eulaText === 'undefined'){
        SecurityService.getEulaData().then(function(data){
          $window.sessionStorage.eulaText = data.result.DataString;
          $window.sessionStorage.eulaHash = data.result.DataObject;
          $templateCache.put('eula-content.html', $window.sessionStorage.eulaText);
          $scope.content = 'eula-content.html';        
        }, function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        });
      }
      else{
        $templateCache.put('eula-content.html', $window.sessionStorage.eulaText);
        $scope.content = 'eula-content.html';
      }
    }

    $scope.acceptEula = function(){
      SecurityService.updateUserEulaHash($window.sessionStorage.eulaHash).then(function(){
        $window.sessionStorage.eulaAccepted = true;
        $location.path('/home');
        AuthenticationService.checkEmailToApprove();
      }, function(error){
        /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        $scope.errorMessage = (error.data.error.frontend_message || undefined);
      });
    };
    $scope.cancel = function(){
      AuthenticationService.logout();
      $location.path('/login');
    };
    $scope.closeEula = function(){
      $location.path('/home');
    };
  }
]);
